import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a7ffc3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "transfer-tip-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "transfer-tip-page__title" }, " 转移通知记录 ", -1))
const _hoisted_3 = { class: "transfer-tip-page__customer" }

import { computed, onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { QuestionFilled } from '@element-plus/icons-vue'
import { CrudSearch, CrudTable } from '@/components/crud-v2'
import { usePagedCrud } from '@/hooks/crud/usePagedCrud'
import { usePermission } from '@/hooks/usePermission'
import { useStore } from '@/store'
import {
  createTransferTipSearchItems,
  transferTipTableColumns
} from './transfer-tip.config'
import {
  fetchTransferTipFilterOptions,
  fetchTransferTipPage
} from './transfer-tip.service'

interface SelectOption {
  label: string
  value: string | number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransferTip',
  setup(__props) {

const filterRules = [
  '满足以下任意条件：',
  '条件1：新客加进来，查近30天内是否添加过业务员，有加过且和业务员还是好友 不判断有没有回复 或 双方语音通话，直接打标签转走',
  '条件2：30天内没加过 或 有加过且已不是好友， 查近180天是否添加过业务员，有加过且和业务员还是好友，且30天内客户有回复过消息，或者双方有语音通话过，打标签转走'
]

const canList = usePermission('transferTip', 'list')
const store = useStore()

const {
  filters,
  pageNo,
  pageSize,
  records,
  total,
  error,
  loading,
  load,
  search,
  reset,
  changePage,
  changePageSize,
  refresh
} = usePagedCrud({
  createFilters: () => ({
    nickName: '',
    usedBy: '',
    groupId: '',
    belongEmpId: '',
    belongCorpId: '',
    createdTime: undefined,
    thirdParty: '',
    sourceLabel: '',
    takeoverStatus: ''
  }),
  fetchPage: fetchTransferTipPage
})

const errorMessage = computed(() =>
  error.value instanceof Error ? error.value.message : ''
)

const usedByOptions = ref<SelectOption[]>([])
const companyOptions = ref<SelectOption[]>([])
const channelOptions = ref<SelectOption[]>([])
const thirdPartyOptions = ref<SelectOption[]>([])
const optionsLoading = ref(false)

const departmentOptions = computed<SelectOption[]>(() =>
  store.state.login.depts.map(
    (item: { id: string | number; name: string }) => ({
      label: item.name,
      value: item.id
    })
  )
)

const searchItems = computed(() =>
  createTransferTipSearchItems({
    usedByOptions: usedByOptions.value,
    departmentOptions: departmentOptions.value,
    companyOptions: companyOptions.value,
    channelOptions: channelOptions.value,
    thirdPartyOptions: thirdPartyOptions.value,
    optionsLoading: optionsLoading.value
  })
)

async function loadFilterOptions() {
  optionsLoading.value = true
  try {
    const options = await fetchTransferTipFilterOptions()
    usedByOptions.value = options.usedBy.map((item) => ({
      label: item.userName,
      value: item.userName
    }))
    companyOptions.value = options.companies.map((item) => ({
      label: item.name,
      value: (item.corPid || item.corpId || item.id)!
    }))
    channelOptions.value = options.channels.map((item) => ({
      label: item,
      value: item
    }))
    thirdPartyOptions.value = options.thirdParties.map((item) => ({
      label: item,
      value: item
    }))
  } catch (cause) {
    ElMessage.error(cause instanceof Error ? cause.message : '筛选项加载失败')
  } finally {
    optionsLoading.value = false
  }
}

function takeoverStatusText(status: number) {
  if (status === 1) return '接替完毕'
  if (status === 2) return '等待接替'
  if (status === 3) return '客户拒绝'
  if (status === 4) return '接替达上限'
  return ''
}

function takeoverStatusType(
  status: number
): 'success' | 'primary' | 'danger' | 'warning' | 'info' {
  if (status === 1) return 'success'
  if (status === 2) return 'primary'
  if (status === 3) return 'danger'
  return status === 4 ? 'warning' : 'info'
}

onMounted(() => {
  if (canList) load()
  loadFilterOptions()
})

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(CrudSearch), {
      model: _unref(filters),
      items: searchItems.value,
      loading: _unref(loading),
      onSearch: _unref(search),
      onReset: _unref(reset)
    }, null, 8, ["model", "items", "loading", "onSearch", "onReset"]),
    _createVNode(_unref(CrudTable), {
      rows: _unref(records),
      "row-key": "userId",
      "page-no": _unref(pageNo),
      "page-size": _unref(pageSize),
      total: _unref(total),
      loading: _unref(loading),
      "error-message": errorMessage.value,
      columns: _unref(transferTipTableColumns),
      onPageChange: _unref(changePage),
      onPageSizeChange: _unref(changePageSize),
      onRetry: _unref(refresh)
    }, {
      title: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_popover, {
          placement: "top",
          width: 720,
          trigger: "hover",
          "popper-class": "is-dark transfer-tip-filter-popover"
        }, {
          reference: _withCtx(() => [
            _createVNode(_unref(QuestionFilled), {
              class: "transfer-tip-page__title-icon",
              "aria-label": "筛选规则"
            })
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filterRules, (item) => {
              return _createElementVNode("div", { key: item }, _toDisplayString(item), 1)
            }), 64))
          ]),
          _: 1
        })
      ]),
      customer: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 30,
            src: row.avatar
          }, null, 8, ["src"]),
          _createElementVNode("span", null, _toDisplayString(row.nickName), 1)
        ])
      ]),
      takeoverStatus: _withCtx(({ row }) => [
        _createVNode(_component_el_tag, {
          type: takeoverStatusType(row.takeoverStatus)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(takeoverStatusText(row.takeoverStatus)), 1)
          ]),
          _: 2
        }, 1032, ["type"])
      ]),
      _: 1
    }, 8, ["rows", "page-no", "page-size", "total", "loading", "error-message", "columns", "onPageChange", "onPageSizeChange", "onRetry"])
  ]))
}
}

})